(function () {
    $ (function () {
        
        window.kealabsLoading = false;
        window.kealabsLoaded = false;
        
        const kealabsSectionsData = {};
        const kealabsSections = document.querySelectorAll('.js-section-kealabs');
        if (kealabsSections.length > 0) {
            kealabsSections.forEach(function(section) {
                const sectionDataset = section.dataset;
                if ('widgetId' in sectionDataset
                    && typeof sectionDataset.widgetId !== 'undefined'
                    && sectionDataset.widgetId !== '') {
    
                    kealabsSectionsData[sectionDataset.widgetId] = sectionDataset;
                }
            });
        }
    
        const renderSections = function(response) {
            const kealabsSections = document.querySelectorAll('.js-section-kealabs');
            
            kealabsSections.forEach(function(section) {
                const data = section.dataset;
            
                if ('widgetId' in data
                    && typeof data.widgetId !== 'undefined'
                    && data.widgetId !== '') {
                    
                    if (data.widgetId in response) {
                        const html = response[data.widgetId];
                        const range = document.createRange();
                        const fragment = range.createContextualFragment(html);
                        const element = fragment.firstElementChild;
    
                        element.classList.add('js-section-from-ajax');
                        element.dataset.widgetId = data.widgetId;
    
                        // инит кнопок избранного
                        if ('ajaxUrlBtnFav' in data
                            && typeof data.ajaxUrlBtnFav !== 'undefined'
                            && data.ajaxUrlBtnFav !== '') {
        
                            const favBtns = element.querySelectorAll('.js-btn-fav');
                            favBtns.forEach(function(btn) {
                                btn.setAttribute('data-ajax-url', data.ajaxUrlBtnFav);
                            })
                        }
    
                        section.insertAdjacentElement('afterend', element);
    
                        // инит книжек (старого формата или нового)
                        if (element.querySelectorAll('.js-book-card').length > 0) {
                            $(document).trigger('reinitItems.books')
        
                        } else if (element.querySelectorAll('.js-book-item').length > 0) {
                            const initEventNew = new Event('init-books', {
                                bubbles: true,
                                cancelable: true
                            });
                            element.dispatchEvent(initEventNew);
                        }
                        if (element.querySelectorAll('.js-product-preview-lecture').length > 0) {
                            element.dispatchEvent(new CustomEvent('ab.product.preview.children.init', {
                                bubbles: true,
                                cancelable: true,
                            }));
                        }
    
                        // инит карусели
                        const carousels = element.querySelectorAll('.js-carousel-books-regular, .js-carousel-books-tiny, .js-carousel-horizontal-rows2');
                        carousels.forEach(function(carousel) {
                            // slick slider init
                            const $carousel = $(carousel);
                            $carousel.trigger('slick:init', [$carousel]);
                        })
                    } else {
                        const blockFiller = document.createElement('div');
                        blockFiller.classList.add('js-section-from-ajax');
                        blockFiller.dataset.widgetId = data.widgetId;
                        section.insertAdjacentElement('afterend', blockFiller);
                    }
                }
            
                section.remove();
            })
        }
        
        const loadSections = function() {
            const kealabsSections = document.querySelectorAll('.js-section-kealabs');
    
            if (kealabsSections.length > 0) {
                const sections = {};
                kealabsSections.forEach(function(section) {
                    window.kealabsLoading = true;
                    const data = section.dataset;
            
                    if ('widgetId' in data
                        && typeof data.widgetId !== 'undefined'
                        && data.widgetId !== '') {
                
                        const ajaxData = {};
                        // todo найти лучшее решение, например, через глобальную переменную
                        const bookPage = document.querySelector('.js-book-page');
                        const isBookPage = !!bookPage;
                        
                        if ('productId' in data && data.productId > 0) {
                            ajaxData.productId = data.productId;
                        } else if (isBookPage) {
                            const offerDependableWidgets = [
                                'product_details_inside_1',
                                'product_details_bottom_1',
                                'product_details_bottom_2'];
                            if (offerDependableWidgets.includes(data.widgetId)) {
                                const bookPageDefaultOfferId = bookPage.dataset.offerId;
                                if (bookPageDefaultOfferId > 0)
                                    ajaxData.productId = bookPageDefaultOfferId;
                            }
                        }
                
                        if ('categoryId' in data && data.categoryId > 0) {
                            ajaxData.categoryId = data.categoryId;
                        }
                        if ('query' in data && typeof data.query !== 'undefined' && data.query !== '') {
                            ajaxData.query = data.query;
                        }
                        if ('customTitle' in data && typeof data.customTitle !== 'undefined' && data.customTitle !== '') {
                            ajaxData.customTitle = data.customTitle;
                        }
                
                        sections[data.widgetId] = ajaxData;
                    }
                })
        
                if (Object.values(sections).length > 0) {
                    $.ajax ({
                            method: 'POST',
                            url: '/ajax/',
                            data: JSON.stringify({
                                'GetKealabsWidget': {
                                    'widget': sections
                                }
                            }),
                            dataType: 'json'
                        })
                        .always (function() {
                            window.kealabsLoading = false;
                        })
                        .done (function(response) {
                            window.kealabsLoaded = true;
                            renderSections(response);
                        })
                    // .fail (function (jqXHR, textStatus, errorThrown) {});
            
                } else {
                    window.kealabsLoading = false;
                }
            }
        };
        
        const resetSections = function() {
            document.querySelectorAll('.js-section-from-ajax').forEach(section => {
                const sectionData = section.dataset;
                if ('widgetId' in sectionData
                    && typeof sectionData.widgetId !== 'undefined'
                    && sectionData.widgetId !== ''
                    && sectionData.widgetId in kealabsSectionsData) {
                    
                    const sectionStoredData = kealabsSectionsData[sectionData.widgetId];
                    const skeletonHtml = 
                        `<section class="section-skeleton section-skeleton_${sectionStoredData.modifier} bgColor-section js-section-kealabs">
                            <div class="section-skeleton__inner"></div>
                        </section>`;
                    
                    const range = document.createRange();
                    const fragment = range.createContextualFragment(skeletonHtml);
                    const element = fragment.firstElementChild;
                    
                    Object.keys(sectionStoredData).forEach(key => {
                        element.dataset[key] = sectionStoredData[key];
                    });
    
                    section.insertAdjacentElement('afterend', element);
                    section.remove();
                }
            });
        };
        
        const refreshSections = function() {
            window.kealabsLoading = false;
            window.kealabsLoaded = false;
            resetSections();
            loadSections();
        };
        
        window.lazyFunctions = window.lazyFunctions || {}; // компонент lazyload
        window.lazyFunctions.kealabs = function() {
            
            // если уже подгружается или уже было подгружено, ничего не делать
            if (window.kealabsLoading || window.kealabsLoaded)
                return false;
    
            loadSections();
        }
    
        document.addEventListener('sectionKealabs.refresh', refreshSections);
    })
} ());
